"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _d = _interopRequireDefault(require("../../lib/d3"));

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _lodash2 = _interopRequireDefault(require("lodash.merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Chart = /*#__PURE__*/function () {
  function Chart() {
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
    var params = arguments.length > 1 ? arguments[1] : undefined;
    var data = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Chart);

    this.container = container;
    this.params = this.defaultParams;
    this.updateParams(params);
    this.init();

    if (data) {
      this.update(data);
    }

    return this;
  }

  _createClass(Chart, [{
    key: "updateParams",
    value: function updateParams(params) {
      this.params = (0, _lodash2.default)(this.params, params);
    }
  }, {
    key: "defaultParams",
    get: function get() {
      return {
        id: Math.round(Math.random() * 100000),
        autoSize: true,
        resizable: true,
        width: 640,
        height: 360,
        extraClasses: [],
        margins: {
          left: 10,
          top: 20,
          right: 10,
          bottom: 20
        }
      };
    }
  }, {
    key: "clipPathId",
    get: function get() {
      var id = this.params.id;
      return "clip-path-".concat(id);
    }
  }, {
    key: "dimensions",
    get: function get() {
      var _this$params = this.params,
          margins = _this$params.margins,
          width = _this$params.width,
          height = _this$params.height;

      if (this.container && this.params.autoSize) {
        width = this.container.offsetWidth;
        height = this.container.offsetHeight;
      }

      return {
        width: width - margins.left - margins.right,
        height: height - margins.top - margins.bottom
      };
    }
  }, {
    key: "append",
    value: function append(data) {
      this.update((this.data || []).concat(data));
    }
  }, {
    key: "update",
    value: function update(data) {
      this.data = data;
      this.draw();
    }
  }, {
    key: "init",
    value: function init() {
      this.initScales();
      this.initDOM();
      this.bindWindowEvents();
    }
  }, {
    key: "bindWindowEvents",
    value: function bindWindowEvents() {
      var _this = this;

      var redraw = function redraw() {
        setTimeout(function () {
          return _this.draw();
        }, 500);
      };

      if (this.params.resizable) {
        window.addEventListener('resize', (0, _lodash.default)(redraw, 500));
        window.addEventListener('orientationchange', redraw);
      }
    }
  }, {
    key: "initDOM",
    value: function initDOM() {}
  }, {
    key: "initScales",
    value: function initScales() {}
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.svg) {
        this.svg.remove();
      }

      if (this.params.resizable) {
        window.removeEventListener('resize', this.handleWindowResize);
      }
    }
  }, {
    key: "draw",
    value: function draw() {// build graph
    }
  }]);

  return Chart;
}();

exports.default = Chart;
;